import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaTypedSchemaDefinition } from './TypedDefinition'

export const SchemaTypedSchemaPlugin = createSchemaPlugin(
  'Schema.TypedSchema',
  SchemaTypedSchemaDefinition
)
